import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { Router } from '@angular/router'
import { language } from '../../../common/json/language'
import { Location, NgClass } from '@angular/common'
import { MatFormField } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [NgClass, MatFormField, MatSelect, FormsModule, MatOption]
})

export class HeaderComponent implements OnInit {
  showLanguageSwitcher: boolean = false
  showBackButton: boolean = false

  @Output() languageChanged = new EventEmitter<string>()
  languageData: any
  defaultLanguage = 'EN'

  constructor (
    public route: Router, private _location: Location
  ) { }

  ngOnInit (): void {
    const sfResponse: any = localStorage.getItem('sfResponse')
    const officeDetails: any = JSON.parse(sfResponse)
    const country = officeDetails?.wir_country_code
    this.languageData = language[country]
    if (!this.route.url.includes('signup') && !this.route.url.includes('signin') && !this.route.url.includes('error') && !this.route.url.includes('thankyou') && this.languageData?.langVal?.length > 1) {
      this.showLanguageSwitcher = true
    }
    if (this.route.url.includes('signup') || this.route.url.includes('signin')){
      this.showBackButton = true
    }
  }

  // This method is used to change the content in selected language
  languageChange (language: any): any {
    this.languageChanged.emit(language)
    localStorage.setItem('languageSelected', language.value)
  }

  backClicked (): void {
    if (this.route.url.includes('signin')) {
      this.route.navigateByUrl('/')
    } else {
      this._location.back()
    }
  }
}
